import { render, staticRenderFns } from "./CurrentMentorship.vue?vue&type=template&id=42848562&scoped=true&"
import script from "./CurrentMentorship.vue?vue&type=script&lang=js&"
export * from "./CurrentMentorship.vue?vue&type=script&lang=js&"
import style0 from "./CurrentMentorship.vue?vue&type=style&index=0&id=42848562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42848562",
  null
  
)

export default component.exports